import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { AccountService } from './account.service';
import { ReportService } from './report.service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root'})
export class ExcelService {

  constructor(
    private accountService: AccountService,
    private reportService: ReportService
  ) { }

  public exportAsExcelFile(json: any[], excelFileName: string, columnTitles?: string[]): void {
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet', worksheet);
    if (columnTitles) {
       
      /// Get the range of the worksheet to determine column boundaries
      const range = XLSX.utils.decode_range(worksheet['!ref']);

      /// For every column in the worksheet, set cell address to that column in the header row      
      /// s = start, e = end, c = column, r = row
      const headerRowNum = 0;
      for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
        const cellAddress = XLSX.utils.encode_cell({ r: headerRowNum, c: colNum });
        const cell = worksheet[cellAddress];
        if (cell) {
          if (columnTitles.length > colNum) {
            /// If alternate title available in columnTitles, rename
            console.log(`Cell ${cellAddress}:`, cell.v);
            const newtitle: string = columnTitles[colNum];
            cell.v = newtitle;
            console.log(`Cell ${cellAddress} newTitle:`, cell.v);
          }
        }
      }
    }

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, `${fileName} (${this.accountService.GetActiveProject().projectTitle}) ${this.reportService.FormattedDateNoSeconds}${EXCEL_EXTENSION}`);
  }

}
